<template>
  <button type="button" class="copy-ip" :class="{ _copied: copied }" :title="copied ? $t('satellites.links.copied') : $t('satellites.links.copy')" @click="copy">
    {{ ip }}
    <SatIcon :name="copied ? 'check' : 'copy'" :size="12" class="copy-ip__icon" />
  </button>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";

// A satellite IP that copies itself to the clipboard on click.
export default {
  name: "CopyIp",
  components: { SatIcon },
  props: {
    ip: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      copied: false,
      timer: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    copy() {
      this.write(this.ip).then(() => {
        this.copied = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => (this.copied = false), 1500);
      });
    },
    // The Clipboard API is missing outside secure contexts and can be denied by the browser, so both fall back to execCommand.
    write(text) {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).catch(() => this.writeLegacy(text));
      return this.writeLegacy(text);
    },
    writeLegacy(text) {
      const area = document.createElement("textarea");
      area.value = text;
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(area);
      return ok ? Promise.resolve() : Promise.reject(new Error("copy failed"));
    },
  },
};
</script>
<style lang="scss" scoped>
.copy-ip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: inherit;
  cursor: pointer;

  &:hover {
    color: var(--sat-accent);
  }

  &._copied {
    color: #37807d;
  }
}

.copy-ip__icon {
  opacity: 0;
  transition: opacity 0.15s;
}

.copy-ip:hover .copy-ip__icon,
.copy-ip._copied .copy-ip__icon {
  opacity: 1;
}
</style>
